const messages = {
    en: {
      subjControlCenter: "Subjects control center",
      atTheMomentSubjList: "At the moment we have tests on these subjects available in our site",
    },
    ru: {
      subjControlCenter: "Центр управления предметами",
      atTheMomentSubjList: "На данный момент на сайте доступны тесты по этим предметам",
    }
  };

  export default messages;